import { slugify } from './Slug';

export type QRSheetType = 'whatsapp' | 'app';

// Shared between QontactPointDetailModalViewModel (which triggers the export)
// and QontactPointQRSheetPdf (which builds/saves the PDF), so both agree on
// the exact same file name without duplicating the slug logic.
export const buildQRSheetFileName = (qrType: QRSheetType, qontactPointName: string): string => {
    const slug = slugify(qontactPointName);
    return `hoja-qr-${qrType}-${slug || 'qontact-point'}.pdf`;
};
